var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-rec-ord-empty",class:{ 'mc-rec-ord-empty--muted': _vm.muted },attrs:{"role":"status"}},[_c('p',{staticClass:"mc-rec-ord-empty__text mb-0"},[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }